module.exports = __webpack_public_path__ + "static/media/anabella.33c9a13f.jpg";